// extracted by mini-css-extract-plugin
module.exports = {"serviceBlock":"ServiceBlock_serviceBlock__1pJ8M","title":"ServiceBlock_title__TwG7e","serviceCardList":"ServiceBlock_serviceCardList__26nB3"};